<template>
  <div id="emailPopover" class="popover" role="tooltip" tag="emailPopover" v-show="show">
    <div id="emailPopoverArrow" data-popper-arrow></div>
    <h3 class="popover-header">
      <button class="close" @click="close()">
        <span aria-hidden="true">x</span>
      </button>
      <span v-if="popperEmail.channel!='s'" v-bind:style="titleStyle" >{{title}}</span>
      <span v-else >Message Details</span>
    </h3>
    <div class="popover-body">
      <template v-if="popperEmail.channel!='s'">
        <span class="small"><b>Subject: </b>
        {{popperEmail.subject}}<br/>
        <b>Sent: </b>{{popperEmail.formatted_dt}}<br/>
        <b>From: </b>{{popperEmail.from_email}}</span>
      </template>
      <template v-else-if="popperEmail.channel=='s'">
        <div>
          <span class="font-weight-semibold">Mobile Number:</span>
          {{popperEmail.mobile_number}}
        </div>
        <div>
          <span class="font-weight-semibold">Sent on:</span>
          {{popperEmail.formatted_dt}}
        </div>
        <div>
          <span class="font-weight-semibold">Short Code:</span>
          {{popperEmail.sender_mobile_code}}
        </div>
        <div v-if="popperEmail.campaign.name">
          <span class="font-weight-semibold">Campaign:</span>
          {{popperEmail.campaign.name}}
        </div>
        <div>
          <span class="font-weight-semibold">Purpose:</span>
        {{popperEmail.campaign.purpose}}
        </div>
        <div v-if="popperEmail.campaign.marketing_program">
          <span class="font-weight-semibold">Marketing Program:</span>
          {{popperEmail.campaign.marketing_program}}
        </div>
        <div v-if="popperEmail.campaign.marketing_strategy">
          <span class="font-weight-semibold">Marketing Strategy:</span>
          {{popperEmail.campaign.marketing_strategy}}
        </div>
      </template>
      <span v-if="popperEmail.channel == 's' && showSmsEvents" v-html="formatSmsEventSummary(popperEmail.events, true)"></span>
      <span v-else-if="showEmailEvents" v-html="formatEventSummary(popperEmail.events, true)"></span>
      
      <template>
        <hr /><a href='#' style='font-size:.9em' @click='showDetail()'>View&nbsp;{{channelCaptions[popperEmail.channel]}}<span class='glyphicons glyphicons-zoom-in'>
        </span></a>
      </template>
    </div>
  </div>  
</template>
<script>
import {mapState} from 'vuex'
import { createPopper } from '@popperjs/core'
import Event from '@/mixins/event'

export default {
  mixins: [Event],
  data: function(){return {
    popperEmail: {},
    popperInstance: null,
    show: false,
    popperReference: null,
    channelCaptions: {
      e: 'email',
      d: 'PDF',
      s: 'message'
    }
  }},
  props: ['isPersonaView'],
  computed: {
    ...mapState({
      showEmailEvents: (state)=>state.user.showEmailEvents,
      showSmsEvents: (state)=>state.user.showSmsEvents,
    }),
    title(){
      let name = this.popperEmail.campaign_display_name;
      return (name) ? name : '';  
    },
    titleStyle(){
      let size = '15px'
      let name = this.popperEmail.campaign_display_name;
      if (name){
        if (name.length > 50) size = '10px';
        if (name.length > 25) size = '12px';
      }
      return {fontSize: size};
    },
  },
  methods: {
    showEmailPopover(item,email){
      const popper = document.querySelector("#emailPopover")
      this.popperReference = item;
      this.popperEmail = email;
      //this.$store.commit("setJourneyPopperEmail", email);
      this.popperInstance = createPopper(item,popper,{
        //placement: 'auto',
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [0, 8],
            },
          },
        ],
      });
      this.show = true;

      this.$nextTick(()=>{
        this.popperInstance.update();
      })
      
    },
    close(){
      this.show = false;
      this.popperReference = null;
    },
    isVisible() {
      return this.show;
    },
    getReference() {
      return this.popperReference;
    },
    showDetail(){
      this.close();
      let view = this.isPersonaView ? 'persona-detail' : 'detail'
      this.$store.commit("setActiveView",view);
    },
  },
};
</script>
<style scoped>
#emailPopover{
  z-index: 200;
  box-shadow: 2px 6px 10px 0px rgba(68,68,68,0.25);
}
.popover-header{
  padding: .5rem .75rem;
  margin-bottom: 0;
  background-color: #f7f7f7;
}
.close {
  float: right;
  margin-top: -3px;
  font-size: 21px;
  font-weight: bold;
  line-height: 1;
  color: #000000;
  text-shadow: 0 1px 0 #ffffff;
  opacity: 0.2;
}
#emailPopoverArrow,
#emailPopoverArrow::before {
  position: absolute;
  width: 12px;
  height: 12px;
  z-index: -1;
}
#emailPopoverArrow::before {
  content: '';
  transform: rotate(45deg);
  border: 1px solid rgba(0, 0, 0, 0.2);
}
#emailPopover[data-popper-placement^='top'] > #emailPopoverArrow {
  bottom: -7px;
}
/* gets rid of inside border of arrow square */
#emailPopover[data-popper-placement^='top'] > #emailPopoverArrow::before {
  border-left-width: 0px;
  border-top-width: 0px;
  background-color: white;
}

#emailPopover[data-popper-placement^='bottom'] > #emailPopoverArrow {
  top: -7px;
}
/* gets rid of inside border of arrow square */
#emailPopover[data-popper-placement^='bottom'] > #emailPopoverArrow::before {
  border-right-width: 0px;
  border-bottom-width: 0px;
  background-color: #f7f7f7;
}


</style>